import React from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// google-fonts
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project import
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

// Import your publishable key
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  root.render(
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        fontFamily: 'Inter, Roboto, Arial, sans-serif',
        background: '#f7f9fc',
        color: '#263247'
      }}
    >
      <div
        style={{
          maxWidth: 520,
          border: '1px solid #d8e3f2',
          borderRadius: 8,
          padding: 24,
          background: '#fff',
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.08)'
        }}
      >
        <h1 style={{ margin: '0 0 12px', fontSize: 24 }}>Missing Clerk configuration</h1>
        <p style={{ margin: '0 0 12px', lineHeight: 1.6 }}>
          Add <code>VITE_CLERK_PUBLISHABLE_KEY</code> to your local Vite environment and restart the dev server.
        </p>
        <p style={{ margin: 0, color: '#65728b', lineHeight: 1.6 }}>
          The app cannot mount authentication without this key. The value is not shown here.
        </p>
      </div>
    </div>
  );
} else {
  // ==============================|| MAIN - REACT DOM RENDER ||============================== //

  root.render(
    <ConfigProvider>
      <ClerkProvider
        appearance={{
          signIn: {
            variables: {
              colorPrimary: 'blue',
              colorText: 'black'
            }
          }
        }}
        publishableKey={PUBLISHABLE_KEY}
        fallbackRedirectUrl="/dashboard"
        afterSignOutUrl="/"
      >
        <App />
      </ClerkProvider>
    </ConfigProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
